import moment from "moment";
import "moment/locale/es";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const getEstadoTexto = (estadoNum) => {
  switch (estadoNum) {
    case 1:
      return "Activo";
    default:
      return "Inactivo";
  }
};

const reporteEmpleadosPdf = (values) => {
  const empresa = values.empresa;
  const logoBiwo = values.logoBiwo;
  let filtrados = [];

  if (values.departamentos && values.departamentos.length > 0) {
    let textoFiltrado = "";
    values.departamentos.map((valueDepartamento) => {
      textoFiltrado += `${valueDepartamento.nombre}\n`;
      return null;
    });
    filtrados.push([
      { text: "Departamentos:", style: "subheader" },
      { text: textoFiltrado, style: "textoChico" },
    ]);
  }

  if (values.puestos && values.puestos.length > 0) {
    let textoFiltrado = "";
    values.puestos.map((valuePuesto) => {
      textoFiltrado += `${valuePuesto.nombre}\n`;
      return null;
    });
    filtrados.push([
      { text: "Puestos:", style: "subheader" },
      { text: textoFiltrado, style: "textoChico" },
    ]);
  }

  if (values.estado !== 3) {
    filtrados.push([
      { text: "Estado:", style: "subheader" },
      { text: getEstadoTexto(values.estado), style: "textoChico" },
    ]);
  }

  if (filtrados.length === 0) {
    filtrados.push([
      { text: "No tiene filtrados adicionales", style: "subheader" },
      { text: "", style: "textoChico" },
    ]);
  }

  const tableHeaders = [
    { text: "Numero", style: "tituloTabla" },
    { text: "Nombre", style: "tituloTabla" },
    { text: "RFC", style: "tituloTabla" },
    { text: "Departamento", style: "tituloTabla" },
    { text: "Puesto", style: "tituloTabla" },
    { text: "Fecha Alta", style: "tituloTabla" },
    { text: "Estado", style: "tituloTabla" },
  ];
  const tableWidths = ["10%", "28%", "14%", "16%", "16%", "10%", "6%"];

  const empleados = (values.empleados || []).map((empleado) => [
    { text: empleado.serieNumero || "N/A", style: "textoTabla", alignment: "left" },
    { text: empleado.nombre || "N/A", style: "textoTabla", alignment: "left" },
    { text: empleado.rfc || "N/A", style: "textoTabla", alignment: "left" },
    { text: empleado.departamento || "N/A", style: "textoTabla", alignment: "left" },
    { text: empleado.puesto || "N/A", style: "textoTabla", alignment: "left" },
    {
      text: empleado.fechaAlta ? moment(empleado.fechaAlta).format("DD/MM/YYYY") : "N/A",
      style: "textoTabla",
      alignment: "center",
    },
    { text: getEstadoTexto(empleado.estado), style: "textoTabla", alignment: "left" },
  ]);

  var dd = {
    footer: {
      image: "logoBiwo",
      alignment: "center",
      width: 80,
    },
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            [
              ...HeaderEmpresaCard(empresa, false, false,
              {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],
                  body: [
                    [{ text: "Fecha de Impresion:", style: "subheader", alignment: "center" }],
                    [{ text: moment().locale("es").format("LL"), style: "textoChico", alignment: "center" }],
                  ],
                },
                layout: "noBorders",
              }),
            ],
          ],
        },
      },
      {
        text: "Reporte de Empleados",
        style: "tableHeaderIzquierda",
      },
      { text: "Datos de filtrado:" },
      {
        style: "tableExample",
        table: {
          widths: ["20%", "80%"],
          body: filtrados,
        },
        layout: {
          hLineWidth: function (i, node) { return 1; },
          vLineWidth: function (i, node) { return 1; },
          hLineColor: function (i, node) { return "#adaaaa"; },
          vLineColor: function (i, node) { return "#adaaaa"; },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) { return null; }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) { return null; }
            return { dash: { length: 2 } };
          },
        },
      },
      {
        style: "tableExample",
        table: {
          widths: tableWidths,
          layout: {
            defaultBorder: true,
          },
          body: [
            tableHeaders,
            ...empleados,
          ],
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            if (rowIndex === 0) {
              return "#cccccc";
            }
            return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
          },
          hLineWidth: function (i, node) { return 1; },
          vLineWidth: function (i, node) { return 1; },
          hLineColor: function (i, node) { return "#adaaaa"; },
          vLineColor: function (i, node) { return "#adaaaa"; },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) { return null; }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) { return null; }
            return { dash: { length: 2 } };
          },
        },
      },
    ],
    images: {
      logo: empresa.logo.base64Completa,
      logoBiwo: logoBiwo.base64Completa,
    },
    styles: {
      tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
      header: {
        fontSize: 9,
        bold: true,
      },
      subheader: {
        fontSize: 8,
        bold: true,
      },
      tableExample: {
        margin: [0, 5, 0, 5],
      },
      textoChico: {
        fontSize: 8,
      },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        style: "subheader",
        alignment: "center",
        border: true,
      },
      textoTabla: {
        fontSize: 8,
        italics: false,
      },
    },
    pageSize: "LETTER",
    pageMargins: [20, 20, 20, 60],
  };
  return dd;
};

export default reporteEmpleadosPdf;
